import React, { useState, useEffect } from "react";
import axios from "axios";
import "./PatternSelect.css";

const PatternSelect = ({ handleSelectPattern }) => {
  const [patterns, setPatterns] = useState([]);

  useEffect(() => {
    axios
      .get("/patterns")
      .then((response) => {
        let pats = response.data.patterns;
        setPatterns(pats);
      })
      .catch((err) => console.log("error" + err));
  }, []);

  return (
    <div className="patternSelectDropdown">
      {patterns.length ? (
        <div className="patternDropdown">
          <p className="dropdownHeading">Pattern</p>
          <select
            className="patternSelectOption"
            onChange={(evt) =>
              handleSelectPattern(
                patterns.filter((pattern) => pattern.title === evt.target.value)
              )
            }
          >
            <option default>Select a pattern...</option>
            {patterns.map((pattern) => (
              <option value={pattern.title} key={pattern.title}>
                {pattern.title}
              </option>
            ))}
          </select>
        </div>
      ) : null}
    </div>
  );
};

export default PatternSelect;
